import { Button, Label, Layout, LayoutHeader, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLiveDemoLinkEmailPhone extends Layout {
    buttonChevron: Button;
    labelE: Label;
    labelEmail: Label;
    labelHeaderTitle: Label;
    labelInstructionsEmail1: Label;
    labelInstructionsEmail2: Label;
    labelInstructionsEmail3: Label;
    labelInstructionsLink1: Label;
    labelInstructionsLink2: Label;
    labelInstructionsLink3: Label;
    labelInstructionsPhone1: Label;
    labelInstructionsPhone2: Label;
    labelInstructionsPhone3: Label;
    labelL: Label;
    labelLink: Label;
    labelP: Label;
    labelPhone: Label;
    layoutheaderLinks: LayoutHeader;
    panelHeader: Panel;
    textboxEmail: Textbox;
    textboxLink: Textbox;
    textboxLinkOptionalText: Textbox;
    textboxPhone: Textbox;
}
